import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../helpers/fetch.js';

import {
  project_portfolio_preset_dashboard_presets_path
} from '~/routes';

export const useDashboardPresets = () => {
  const presetsQuery = useQuery({
    queryKey: ['project_portfolio_preset_dashboard_presets'],
    queryFn: () => fetchJson(project_portfolio_preset_dashboard_presets_path()),
    enabled: true,
    staleTime: 5 * 60 * 1000
  });

  const presets = presetsQuery.data;
  const isLoading = presetsQuery.isLoading;
  const isError = presetsQuery.isError;
  const error = presetsQuery.error;

  return {
    presets,
    isLoading,
    isError,
    error,
    refetch: presetsQuery.refetch
  };
};
